import React, { FC } from 'react';

const YM_HIDE_CONTENT_CLASS_NAME = 'ym-hide-content';

export const WebvisorDataHidingContainer: FC = ({ children }) => {
	return <div className={YM_HIDE_CONTENT_CLASS_NAME}>{children}</div>;
};
